export const PROMO_SLOT_PRIORITIES = {
  DDP_INTRODUCTION: 100,
  RATE_SHOPPER_POPUP: 50,
} as const;
